define("shared/components/shared/wistia-video", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  
  <div class={{concat-classes "wistia_responsive_padding" this.paddingClass}} data-test-id="wistia-video-padding">
    <div class={{concat-classes "wistia_responsive_wrapper" this.wrapperClass}} data-test-id="wistia-video-wrapper">
      <div
        class={{concat-classes this.videoEmbedClass "videoFoam=true" this.embedClass}}
        data-test-id="wistia-video-embed"
      >
        <div class={{concat-classes "wistia_swatch" this.swatchClass}} data-test-id="wistia-video-swatch">
          {{! template-lint-disable no-potential-path-strings }}
          <img
            alt
            aria-hidden="true"
            class={{this.coverClass}}
            data-test-id="wistia-video-swatch-cover"
            onload="this.parentNode.style.opacity=1;"
            src={{this.videoSwatchImageUrl}}
          />
        </div>
      </div>
    </div>
  </div>
  */
  {
    "id": "j9Ax/mDU",
    "block": "[[[1,\"\\n\"],[10,0],[15,0,[28,[37,0],[\"wistia_responsive_padding\",[30,0,[\"paddingClass\"]]],null]],[14,\"data-test-id\",\"wistia-video-padding\"],[12],[1,\"\\n  \"],[10,0],[15,0,[28,[37,0],[\"wistia_responsive_wrapper\",[30,0,[\"wrapperClass\"]]],null]],[14,\"data-test-id\",\"wistia-video-wrapper\"],[12],[1,\"\\n    \"],[10,0],[15,0,[28,[37,0],[[30,0,[\"videoEmbedClass\"]],\"videoFoam=true\",[30,0,[\"embedClass\"]]],null]],[14,\"data-test-id\",\"wistia-video-embed\"],[12],[1,\"\\n      \"],[10,0],[15,0,[28,[37,0],[\"wistia_swatch\",[30,0,[\"swatchClass\"]]],null]],[14,\"data-test-id\",\"wistia-video-swatch\"],[12],[1,\"\\n\"],[1,\"        \"],[10,\"img\"],[14,\"alt\",\"\"],[14,\"aria-hidden\",\"true\"],[15,0,[30,0,[\"coverClass\"]]],[14,\"data-test-id\",\"wistia-video-swatch-cover\"],[14,\"onload\",\"this.parentNode.style.opacity=1;\"],[15,\"src\",[30,0,[\"videoSwatchImageUrl\"]]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"concat-classes\"]]",
    "moduleName": "shared/components/shared/wistia-video.hbs",
    "isStrictMode": false
  });
  let WistiaVideoComponent = _exports.default = (_class = class WistiaVideoComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "wistiaVideo", _descriptor, this);
      this.wistiaVideo.setup(this.videoUrl);
      this.wistiaVideo.trackPercentWatched(this.args.videoId, this.args.percentTrigger || 0.25, this.args.trackPayload || {}, this.args.onWatched);
    }
    willDestroy() {
      super.willDestroy();
      this.wistiaVideo.revoke(this.args.videoId);
    }
    get videoUrl() {
      return `https://fast.wistia.com/embed/medias/${this.args.videoId}.jsonp`;
    }
    get videoSwatchImageUrl() {
      return this.args.swatchImageUrl || `https://fast.wistia.com/embed/medias/${this.args.videoId}/swatch`;
    }
    get videoEmbedClass() {
      return `wistia_embed wistia_async_${this.args.videoId}`;
    }
    get paddingClass() {
      return this.args.paddingClass || '--wistia__video_padding';
    }
    get wrapperClass() {
      return this.args.wrapperClass || '--wistia__video_responsive_wrapper';
    }
    get embedClass() {
      return this.args.embedClass || '--wistia__video_embed';
    }
    get swatchClass() {
      return this.args.swatchClass || '--wistia__video_swatch';
    }
    get coverClass() {
      return this.args.coverClass || '--wistia__video_cover';
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "wistiaVideo", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WistiaVideoComponent);
});